module.exports = __webpack_public_path__ + "img/posterSearch-des6.cf7e7fdb.png";